
<div [formGroup]="group"  class="form-input {{config.class}}" *ngIf="!config.isNativeControl" [hidden]="config.hide">
    <div for="" class="default-sub-header text-label label-section" *ngIf="config.label && !config.appearanceOutline">        
        {{config.label | translate}} <span *ngIf="config.isMandatory" class="mandatory-field">*</span>
        <span *ngIf="config.icon" class="view-icon" (click)="tooltip.toggle()" #tooltip="matTooltip" matTooltipPosition="right"  matTooltip="{{config.toolTip}}" class="{{config.icon}}"></span>
    </div>
    <!-- <div for="" class="section-header text-label" *ngIf="config.label && !config.isTranslate">{{config.label}}</div> -->
    <mat-form-field  [ngClass]="{'input-with-boundary':config.appearance}" class="basic-select-dropdown"  [appearance]="config.appearanceOutline ? 'outline': 'none'">
        <mat-label *ngIf="!config.icon && config.label && config.appearanceOutline">{{config.label | translate}}</mat-label>
        <mat-select [disabled]="config.disableSelect" (selectionChange)="selectedOption($event)" placeholder="{{config.placeholder | translate}}"  [formControlName]="config.name" [value]="config.id" [attr.name]="config.name" disableOptionCentering= 'true' >
            <mat-option *ngFor="let option of config.options" [value]="option.id">  
                                   
                <span *ngIf="!config.isDateTime" matTooltipClass="tooltip-class" title="{{option.value | translate}}">{{ option.value | translate  }}</span>
                <span *ngIf="config.isDateTime" matTooltipClass="tooltip-class" title="{{option.value | localizeDate: 'LT'}}">{{ option.value | localizeDate: 'LT' }}</span>
            </mat-option>
        </mat-select>       
    </mat-form-field>
</div>
<div [formGroup]="group"  class="form-input {{config.class}}" *ngIf="config.isNativeControl" [hidden]="config.hide">
    <div for="" class="default-sub-header text-label label-section" *ngIf="config.label">
        {{config.label | translate}}
        <span *ngIf="config.icon" class="view-icon" (click)="tooltip.toggle()" #tooltip="matTooltip" matTooltipPosition="right"  matTooltip="{{config.toolTip}}" class="{{config.icon}}"></span>
    </div>
    <!-- <div for="" class="section-header text-label" *ngIf="config.label && !config.isTranslate">{{config.label}}</div> -->
    <mat-form-field  [ngClass]="{'input-with-boundary':config.appearance}" class="basic-select-dropdown">
       
        <select [disabled]="config.disableSelect" (change)="selectedOption($event)" placeholder="{{config.placeholder | translate}}"  [formControlName]="config.name" [value]="config.id" [attr.name]="config.name" disableOptionCentering='true' matNativeControl>
            <option *ngFor="let option of config.options" [value]="option.id">
                <span *ngIf="!config.isDateTime" matTooltipClass="tooltip-class" title="{{option.value}}">{{ option.value  }}</span>
                <span *ngIf="config.isDateTime" matTooltipClass="tooltip-class" title="{{option.value | localizeDate: 'LT'}}">{{ option.value | localizeDate: 'LT' }}</span>
            </option>
          </select>
    </mat-form-field>
</div>

 




